import { NgModule, ModuleWithProviders } from '@angular/core';
import { EnumToArrayPipe } from './EnumToArrayPipe';
import { CommonModule } from '@angular/common';
import { CallbackPipe } from './callback.pipe';


@NgModule({
  imports: [
    // other dependencies for the pipes to work
    CommonModule
  ],
  declarations: [
    EnumToArrayPipe,
    CallbackPipe
  ],
  exports: [
    EnumToArrayPipe,
    CallbackPipe
  ],
  providers: [
    // add any providers here if the pipe depends on it
  ]
})
export class ApplicationPipesModule {
  // from https://stackoverflow.com/questions/47821680/dependency-in-angular-importing-and-exporting-of-module
  // intended to be imported by AppModule (including services)
  static forRoot() {
    return {
      ngModule: ApplicationPipesModule,
      providers: [
        // any providers which need to be accessable through app module
      ]
    }
  }

  // intended to be imported by FeatureModules (excluding services)
  static forChild() {
    return {
      ngModule: ApplicationPipesModule,
      providers: []
    }
  }
}